import { error, finish } from '../../../modules/related-contingency/actions/get-related-contingency';
import api from '../../../api';

export function request(dispatch, { body }) {
    api.get('/contingencies/tag-management')
        .then(res => {
            dispatch(finish(res || {}));
        }).catch(err => {
            dispatch(error(err));
        });
}
